import { createClient } from 'react-fetching-library';

import { requestHostInterceptor } from './requestInterceptors/requestHostInterceptor';
import { responseInterceptor } from './responseInterceptors/responseInterceptor';

export const client = createClient({
  requestInterceptors: [requestHostInterceptor],
  responseInterceptors: [responseInterceptor],
});
